import ABSScrollbars from '@abs/core/ABSScrollbars';
import { styled } from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import ListSubheader from '@mui/material/ListSubheader';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Typography from '@mui/material/Typography';
import withReducer from 'app/store/withReducer';
import format from 'date-fns/format';
import { memo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ABSSvgIcon from '@abs/core/ABSSvgIcon';
import reducer from './store';
import { selectHelpPanelState, toggleHelpPanel } from './store/stateSlice';
import { useTranslation } from 'react-i18next';
import { Button, TextField } from '@mui/material';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import { communicateWithAPI } from '../../../store/helperSlice';
import absWebService from 'app/services/absWebService';
import { Link } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  roundedborder: {
    borderColor: theme.palette.primary.dark,
    borderRadius: "8px",
    '& fieldset': {
      borderColor: theme.palette.primary.dark,
      borderRadius: "8px",
    },
  },
}));

const StyledSwipeableDrawer = styled(SwipeableDrawer)(({ theme }) => ({
  '& .MuiDrawer-paper': {
    width: 375,
  },
}));

function HelpPanel(props) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const state = useSelector(selectHelpPanelState);
  const { t } = useTranslation('abslayouts');
  const [instantmessage, setInstantmessage] = useState("");

  const handleInstantmessageChange = (event) => {
    setInstantmessage(event.target.value);
  }

  const handleSend = () => {
    dispatch(communicateWithAPI("abs_supportrequest", instantmessage));
    dispatch(toggleHelpPanel())
  }

  return (
    <StyledSwipeableDrawer
      open={state}
      anchor="right"
      onOpen={(ev) => { }}
      onClose={(ev) => dispatch(toggleHelpPanel())}
      disableSwipeToOpen
    >
      <ABSScrollbars>
        <ListSubheader component="div" className='flex flex-row justify-between'>
          <Typography
            className="items-center flex md:hidden"
            role="button"
            onClick={() => dispatch(toggleHelpPanel())}
            color="textprimary">
            <ABSSvgIcon size={24}>heroicons-outline:arrow-sm-left</ABSSvgIcon>
          </Typography>
          {t("DATE_WEEKDAY", { date: new Date() })},&nbsp;{format(new Date(), 'dd')}.&nbsp;{t("DATE_MONTH", { date: new Date() })}&nbsp;{format(new Date(), 'yyyy')}
        </ListSubheader>

        <div className="mb-0 p-16 px-24">
          <Typography className="mb-12 text-24 w-full text-center" color="color.primary">
            {t("YOUNEEDHELP")}
          </Typography>
          <Typography className="mb-12 text-18 w-full text-center" color="text.secondary">
            {t("WEAREHERETOHELP")}!
          </Typography>
          <Typography className="mb-12 text-16 w-full text-center" color="text.primary">
            <a href="https://alpsware.at/downloads/#quicksupport" target="_blank">QuickSupport Download</a>
          </Typography>
        </div>
        <Divider />
        <div className="mb-0 py-16 px-24">
          <div className='flex flex-row w-full justify-center mb-12'>
            <Typography className="text-24 text-center" color="color.primary">
              {t("PHONE")}
            </Typography>
            <ABSSvgIcon className="mt-4 ml-8">feather:phone</ABSSvgIcon>
          </div>
          <Typography className="mb-12 text-14 w-full text-center" color="text.primary">
            {t("PHONESUBMESSAGE")}!
          </Typography>
          <Typography className="mb-12 text-18 w-full text-center" color="text.primary">
            <a href="tel:++43463203444">+43 463 203 444</a>
          </Typography>
          <Typography className="mb-12 text-14 w-full text-center" color="text.primary">
            {t("OPENINGHOURS")}
          </Typography>
        </div>
        <Divider />
        <div className="mb-0 py-16 px-24">
          <div className='flex flex-row w-full justify-center mb-12'>
            <Typography className="text-24 text-center" color="color.primary">
              {t("MESSAGE")}
            </Typography>
            <ABSSvgIcon className="mt-4 ml-8">feather:message-square</ABSSvgIcon>
          </div>
          <Typography className="mb-16 text-14 w-full text-center" color="text.primary">
            {t("MESSAGESUBMESSAGE")}!
          </Typography>
          <TextField label={t("YOURMESSAGE")} className={clsx(classes.roundedborder, "w-full")} multiline minRows='8' variant="outlined" color="inherit" value={instantmessage} onChange={handleInstantmessageChange} />
          <Button variant="outlined" color="primary" className="mt-12" disabled={instantmessage == ""} onClick={handleSend}>{t("SEND")}</Button>
        </div>
        <Divider />
        <div className="mb-0 py-16 px-24">
          <div className='w-full flex flex-col items-center text-12'>
            <div className="text-gray-500">{"Frontend: " + absWebService.getSoftwareVersion()}</div>
            {absWebService.getBackendVersion() && (
              <div className="text-gray-500">{"Backend: " + absWebService.getBackendVersion()}</div>
            )}
            <Link
              to="/changelog"
              className="text-primary mt-8 hover:underline"
              onClick={() => dispatch(toggleHelpPanel())}
            >
              {t("VIEWCHANGELOG")}
            </Link>
          </div>
        </div>
      </ABSScrollbars>
    </StyledSwipeableDrawer>
  );
}

export default withReducer('helpPanel', reducer)(memo(HelpPanel));
